<script>
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config";
import Swal from "sweetalert2"
import 'vue3-lottie/dist/style.css'

import exportFromJSON from "export-from-json"
import moment from "moment/moment";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Orçamentos",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader , Loader,   },

  mounted() {
    console.log('mounted movimentos-list_0')

    this.atualizaDataList()
  },

  data() {
    return {

      title: 'Movimentos',
      items: [
        {
          text: 'Comercial',
          href: '/',
        },
        {
          text: 'Movimentos',
          active: true,
        },
      ],
      loadingList: true,

      movList: null,

      pesqTextFilter: '',
      statusFilter: 'DF',
      valorTotal: 0,
      valorTotalConf: 0,
      valorTotalElab: 0,
      valorTotalFat: 0,
    }
  },
  setup() {

  },


  methods: {

    editar(dataID){
      console.log('editar: ' + dataID)
      this.$router.push(`/movimento/editar/${dataID}`)

    },

    nomeStatus(stsIn){
      let result = 'Não Definido'
      switch (stsIn) {
        case 'EL':
          result = 'Elabotação'
          break
        case 'CO':
          result = 'Confrmado'
          break
        case 'SE':
          result = 'Separado'
          break
        case 'CA':
          result = 'Cancelado'
          break
      }
      return result
    },



    exportExcel(){
      console.log('exportExcel')
      const data = this.movList
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },


    atualizaDataList(){
      this.loadingList = true
      api.get(`${getBaseUrl()}api/movs`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)

        this.movList = res.data[0]
        this.title = `(${this.movList.length}) Movimentos`
        this.loadingList = false




        let valorTotalLoc = 0
        let valorTotalConf = 0
        let valorTotalElab = 0
        let valorTotalFat = 0
        this.movList.forEach((value) => {

          valorTotalLoc += value.valorliq

          if (value.status === 'EL'){
            valorTotalElab += value.valorliq
          } else if (value.status === 'CO'){
            valorTotalConf += value.valorliq
          } else if (value.status === 'FA'){
            valorTotalFat += value.valorliq
          }

        })

        this.valorTotal = valorTotalLoc
        this.valorTotalElab = valorTotalElab
        this.valorTotalConf = valorTotalConf
        this.valorTotalFat = valorTotalFat


      });
    },

    deletaReg(dataID) {
      console.log('deletaReg_pai dataID:')
      console.log(dataID)
      this.loadingList = true
      api.delete(`${getBaseUrl()}api/mov`, {
        params: {
          'iddata': dataID
        }
      }).then((res) => {
        console.log('then axios delete')
        console.log(res.data)
        this.atualizaDataList()
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações excluídas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })
    },



    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 4});
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    }


  },
}

</script>

<template>
  <Layout>

    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" >
            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilter"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-1">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectStatus"
                        v-model="statusFilter"
                        @change="atualizaDataList"
                        class="form-control select2-search-disable">
                      <option value="DF" selected>EL / CA</option>
                      <option value="T" selected>Todos</option>
                      <option value="CO">Confirmado</option>
                      <option value="EL">Elaboração</option>
                      <option value="FA">Fatrurado</option>
                      <option value="CA">Cancelados</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-2" >

                <b-dropdown
                    ngbDropdown
                    menu-class="dropdown-menu-md dropdown-menu-end"
                    right
                    variant="light">
                  <template v-slot:button-content>
                    <i class="mdi mdi-help me-1"></i>
                    <span class="d-none d-sm-inline-block" ngbDropdownToggle>
                      Auxiliar
                      <i class="mdi mdi-chevron-down"></i>
                    </span>
                  </template>


                  <div v-if="!loadingList">
                    <div class="dropdown-item-text">
                      <div>
                        <p class="text-muted mb-2">Total</p>
                        <h5 class="mb-0">{{ formatDecimal(valorTotal) }} (Valor Total) </h5>
                      </div>
                    </div>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item>
                      Faturado:
                      <span class="float-end"> {{ formatDecimal(valorTotalFat) }} (0%)</span>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      Confirmado:
                      <span class="float-end"> {{ formatDecimal(valorTotalConf) }} (0%)</span>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      Com Elaboração:
                      <span class="float-end"> {{ formatDecimal(valorTotalElab) }} (0%)</span>
                    </b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>
                    <a class="dropdown-item text-primary text-center"
                       @click="exportExcel"
                       href="javascript: void(0);">
                      Exportar Excel
                    </a>

                    <b-dropdown-divider></b-dropdown-divider>
<!--                    <a class="dropdown-item text-primary text-center"-->
<!--                       @click="emitRelat001"-->
<!--                       href="javascript: void(0);">-->
<!--                      Relatório de Movimentos Diário-->
<!--                    </a>-->

<!--                    <a class="dropdown-item text-primary text-center"-->
<!--                       @click="emitRelat002"-->
<!--                       href="javascript: void(0);">-->
<!--                      Relatório de Movimentos Mês-->
<!--                    </a>-->

<!--                    <a class="dropdown-item text-primary text-center"-->
<!--                       @click="emitRelat003"-->
<!--                       href="javascript: void(0);">-->
<!--                      Movimentos por Representante-->
<!--                    </a>-->

                  </div>

                </b-dropdown>
              </div>



              <div class="col-sm-7">
                <div class="text-sm-end">
                  <router-link :to="`/movimento/importar/0`">
                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2" >
                      <i class="mdi mdi-plus me-1"></i> Novo Movimento
                    </button>
                  </router-link>

                </div>
              </div>
            </div>

            <Loader v-if="loadingList" style="min-height: 300px;">
            </Loader>

            <div class="table-responsive mb-0">

              <table class="table align-middle table-nowrap">
                <thead class="table-light">
                <tr>
                  <th class="align-middle">ID</th>
                  <th class="align-middle">Número</th>
                  <th class="align-middle">Nome</th>
                  <th class="align-middle">Email / Telefone</th>
                  <th class="align-middle">Status</th>
                  <th class="align-middle">Cidade</th>
                  <th class="align-middle">Forma</th>
                  <th class="align-middle">Criado</th>
                  <th class="align-middle text-end">Peso</th>
                  <th class="align-middle text-end">Valor</th>
                  <th class="align-middle">Ações</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in movList" :key="data.id">

                  <td>
                    <a href="javascript: void(0);" class="text-body fw-bold" @click="editar(data.id)">
                      #{{ data.id }}
                    </a>
                  </td>

                  <td>
                    {{ data.codigo }}
<!--                    <div v-if="!data.image" class="avatar-xs">-->
<!--                      <span class="avatar-title rounded-circle">{{ data.cliente ? data.cliente.substring(0, 3) : '' }}</span>-->
<!--                    </div>-->
                  </td>

                  <td>{{ data.nome }} </td>

                  <td>{{ data.email }} <br> {{ data.tel1 }}  </td>

                  <td>
              <span class="badge badge-pill badge-soft-success font-size-11"
                    :class="data.status === 'SE' ? 'badge-soft-success' :
                    data.status === 'EL' ? 'badge-soft-warning' : data.status === 'CO' ? 'badge-soft-info' : 'badge-soft-danger'"
              >
                {{ nomeStatus(data.status)  }}
              </span>
                  </td>

                  <td> {{ data.cidade }}</td>


                  <td>
                  <span class="badge bg-success font-size-12">
                    <i class="mdi mdi-star me-1"></i>
                    {{ data.id }}
                  </span>
                  </td>

                  <td>{{ formatDateTime(data.created_at) }} </td>
                  <td class="text-end">{{ formatDecimal(data.peso) }} </td>
                  <td class="text-end">{{ formatDecimal(data.valorliq) }} </td>

                  <td>
                    <div class="button-items">

                      <b-button variant="outline-success" @click="detalhes(data.id)">
                        <i class="mdi mdi-eye d-block font-size-16"></i>
                      </b-button>

                      <b-button variant="outline-warning" @click="editar(data.id)" :disabled="data.email === 'admin@admin.com.br'">
                        <i class="mdi mdi-pencil d-block font-size-16"></i>
                      </b-button>

                    </div>
                  </td>


                </tr>
                </tbody>
              </table>


<!--              <b-modal :title="titleModalItensPed" v-model="showModalItensPed" centered hide-footer>-->

<!--                <div class="row" v-if="loadingOrctoDetail">-->
<!--                  <div class="col-12 text-center">-->
<!--                    <b-spinner type="grow"-->
<!--                               class="m-6 mx-2"-->
<!--                               variant="secondary"-->
<!--                               role="status">-->
<!--                    </b-spinner>-->
<!--                    <b-spinner type="grow"-->
<!--                               class="m-6 mx-2"-->
<!--                               variant="secondary"-->
<!--                               role="status">-->
<!--                    </b-spinner>-->
<!--                    <b-spinner type="grow"-->
<!--                               class="m-6 mx-2"-->
<!--                               variant="secondary"-->
<!--                               role="status">-->
<!--                    </b-spinner>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div v-if="!loadingOrctoDetail && orctoData && clienteData">-->

<!--                  <p class="mb-2">-->
<!--                    Código:-->
<!--                    <router-link :to="`/orcamento/editar/${orctoData.id}`" target="_blank">-->
<!--                      <span class="text-primary">{{ orctoData.id }}</span>-->
<!--                    </router-link>-->
<!--                  </p>-->
<!--                  <p class="mb-4">-->
<!--                    <router-link :to="`/cliente/detalhe/${clienteData.id}`" target="_blank">-->
<!--                      Cliente:-->
<!--                      <span class="text-primary">{{ orctoData.cliente }} - {{ clienteData.nome }}</span>-->
<!--                    </router-link>-->
<!--                  </p>-->
<!--                  <div class="table-responsive">-->
<!--                    <table class="table table-centered table-nowrap">-->
<!--                      <thead>-->
<!--                      <tr>-->
<!--                        <th scope="col">Produto</th>-->
<!--                        <th scope="col">Descrição</th>-->
<!--                        <th scope="col" class="text-end">Valor (R$)</th>-->
<!--                      </tr>-->
<!--                      </thead>-->
<!--                      <tbody>-->

<!--                      <tr v-for="data in orctoItensData" :key="data.id">-->
<!--                        <th scope="row">-->
<!--                          <h5 class="text-muted mb-0">{{ data.produto.substr(7, 15) }} </h5>-->
<!--                          <div>-->
<!--                            <img v-if="data.img1"-->
<!--                                 :src="data.img1"-->
<!--                                 alt-->
<!--                                 class="avatar-sm"/>-->
<!--                            <span-->
<!--                                v-else-->
<!--                                class="avatar-title rounded-circle" style="min-height: 50px;">{{ data.produto.substring(0, 3) }}</span>-->
<!--                          </div>-->

<!--                        </th>-->
<!--                        <td>-->
<!--                          <div>-->

<!--                            <h5 class="text-truncate font-size-14 mb-0">-->
<!--                              {{ data.descprod.substring(0, 28) }}-->
<!--                            </h5>-->
<!--                            <p class="text-muted mb-0">R$ {{ formatDecimal(data.vlrunitliq) }} x {{ formatInteger(data.qtd) }}</p>-->
<!--                          </div>-->
<!--                        </td>-->
<!--                        <td class="text-end">{{ formatDecimal(data.vlrtotalliq) }}</td>-->
<!--                      </tr>-->

<!--                      <tr>-->
<!--                        <td colspan="2">-->
<!--                          <h6 class="m-0 text-end">Sub Total:</h6>-->
<!--                        </td>-->
<!--                        <td class="text-end">R$ {{ formatDecimal(valorTotalItens) }}</td>-->
<!--                      </tr>-->

<!--                      <tr>-->
<!--                        <td colspan="2">-->
<!--                          <h6 class="m-0 text-end">Frete:</h6>-->
<!--                        </td>-->
<!--                        <td class="text-end">Grátis</td>-->
<!--                      </tr>-->

<!--                      <tr>-->
<!--                        <td colspan="2">-->
<!--                          <h6 class="m-0 font-size-14  text-end">Total:</h6>-->
<!--                        </td>-->
<!--                        <td class="font-size-14 text-end">R$ {{ formatDecimal(valorTotalItens) }}</td>-->
<!--                      </tr>-->

<!--                      </tbody>-->
<!--                    </table>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </b-modal>-->


            </div>





          </div>

        </div>
      </div>
    </div>





  </Layout>
</template>

